var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "minimap", class: _vm.mapClass() }, [
    _c(
      "div",
      {
        ref: "area",
        staticClass: "area",
        on: {
          mousedown: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
          },
        },
      },
      [
        _vm._l(_vm.nodes, function (node) {
          return _c("div", {
            staticClass: "mini-node",
            style: _vm.nodeStyle(node),
          })
        }),
        _c("div", {
          ref: "viewport",
          staticClass: "mini-viewport",
          style: _vm.viewportStyle(),
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }